import React from "react";

export default function Bullying(props) {
  return (
    <div>
      <h1 className="text-3xl font-bold mb-6 text-yellow-500">Bullying</h1>

      <div className="space-y-5">
        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <span className="text-gray-700 block mb-1">
            Every child has the right to experience sport in a safe environment
            free from abuse and bullying. Slum Soccer/ Krida Vikas Sanstha shall
            endeavor to create a positive ethos that challenges bullying by
            empowering children to understand the impact of bullying, how best
            to deal with it and by implementing appropriate standard of behavior
            amongst all the children.
          </span>
        </div>
      </div>
    </div>
  );
}
